import script from "./ProcedureSumming.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProcedureSumming.vue?vue&type=script&setup=true&lang=ts"

import "./ProcedureSumming.vue?vue&type=style&index=0&id=b055afe0&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b055afe0"]])

export default __exports__